/**
 * CTableCellInput
 * @author Tevin
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export class CTableCellInput extends React.Component {
    static propTypes = {
        // 样式名
        className: PropTypes.string,
        // 样式
        style: PropTypes.object,
        // 列号
        colIndex: PropTypes.number,
        // 行号
        rowIndex: PropTypes.number,
        // 划区选择时，选中状态
        drawState: PropTypes.string,
        // 项值，datas 其中一项
        value: PropTypes.any,
        // 项的其他内容
        datas: PropTypes.any,
        // 是否可编辑
        editable: PropTypes.bool,
        // 输入框单位名
        editSuffix: PropTypes.string,
        // 显示文本
        children: PropTypes.node,
        // 输入回调
        onColumnChange: PropTypes.func,
        // 选择划区开始回调
        onSelectDrawStart: PropTypes.func,
        // 粘贴区域
        onPasteArea: PropTypes.func,
    };

    static defaultProps = {
        editable: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            value: props.value,
        };
        this.$refs = {};
        this._listeners = {};
        this._data = {
            pasting: false,
        };
    }

    componentDidMount() {
        this._data.mount = true;
    }

    componentWillUnmount() {
        this._data.mount = false;
    }

    _handleStartEditing() {
        if (!this.props.editable) {
            return;
        }
        // 划区时跳过
        if (this.props.drawing) {
            return;
        }
        this.setState({
            editing: true,
            value: this.props.value,
        });
        setTimeout(() => {
            this.$refs.input && this.$refs.input.focus();
        }, 100);
        // 关闭上一个编辑状态
        if (CTableCellInput.lastEditCell && CTableCellInput.lastEditCell !== this) {
            CTableCellInput.lastEditCell.$cancelEdit();
        }
        CTableCellInput.lastEditCell = this;
    }

    _handeChange(evt) {
        // 粘贴中跳过
        if (this._data.pasting) {
            return;
        }
        const valStr = evt.target.value
            .replace(/[^\d.-]/g, '')
            .replace(/(\.\d{2})\d*/, '$1');
        const value = Number(valStr);
        if (value === this.state.value) {
            this.setState({
                value: valStr,
            });
            return;
        }
        this.setState({
            value: valStr,
        });
        this.props.onColumnChange({
            ...this.props.datas,
            value,
        });
    }

    _handlePaste(evt) {
        const content = evt.clipboardData.getData('text/plain');
        if (content.match(/[\t\n ]/)) {
            this.props.onPasteArea({
                start: [this.props.colIndex, this.props.rowIndex],
                content,
            });
            // 粘贴中状态，阻止change生效
            this._data.pasting = true;
            setTimeout(() => {
                this._data.pasting = false;
            }, 100);
        } else {
            return;
        }
    }

    _handleEndEditing() {
        this.setState({ editing: false });
        CTableCellInput.lastEditCell = this;
    }

    _renderInput() {
        if (this.props.editable) {
            return (
                <span className="edit-input">
                    <Input
                        value={this.state.value}
                        suffix={this.props.editSuffix}
                        ref={elm => (this.$refs.input = elm)}
                        onChange={evt => this._handeChange(evt)}
                        onBlur={evt => this._handleEndEditing(evt)}
                        onPaste={evt => this._handlePaste(evt)}
                    />
                </span>
            );
        } else {
            return null;
        }
    }

    _renderChildren() {
        if (this.props.editable) {
            return (
                <div
                    className={['children', this.props.drawState || 'normal'].join(' ')}
                    data-array={this.props.colIndex + '-' + this.props.rowIndex}
                    onClick={evt => this._handleStartEditing()}
                    onMouseDown={evt => {
                        this.props.onSelectDrawStart(evt);
                    }}
                >
                    <span className="text">{this.props.children}</span>
                    <EditOutlined />
                </div>
            );
        } else {
            return this.props.children;
        }
    }

    render() {
        return (
            <td
                className={[
                    this.props.className,
                    'c-editable-table-cell',
                    this.state.editing && !this.props.drawState ? 'editing' : '',
                ].join(' ')}
                style={this.props.style}
            >
                {this._renderChildren()}
                {this._renderInput()}
            </td>
        );
    }

    $cancelEdit() {
        if (!this._data.mount) {
            return;
        }
        this.setState({
            editing: false,
        });
    }

    static lastEditCell = null;
}
